// extracted by mini-css-extract-plugin
module.exports = {"navbar":"panelNavbar_navbar__1mdnN","toggle":"panelNavbar_toggle__kJp9o","logo":"panelNavbar_logo__hP9PX","dropdown-menu":"panelNavbar_dropdown-menu__20Sqe"};